// src/PageSkeleton.jsx
export default function PageSkeleton() {
    return (
        <div className="relative w-full h-screen bg-white text-black overflow-hidden animate-pulse">

        {/* CONTENT SECTION 1 */}
        <div className="mx-auto mt-[5rem] w-[90%] md:w-[70%] flex flex-col gap-6">
            <div className="w-full h-48 rounded-2xl bg-neutral-200" />
            <div className="flex flex-col gap-3">
            <div className="h-5 w-1/2 bg-neutral-300 rounded" />
            <div className="h-4 w-4/5 bg-neutral-300 rounded" />
            <div className="h-4 w-3/5 bg-neutral-300 rounded" />
            </div>
        </div>

        {/* CONTENT SECTION 2 */}
        <div className="mx-auto mt-10 w-[90%] md:w-[70%] flex flex-col gap-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="h-40 rounded-2xl bg-neutral-200" />
            <div className="h-40 rounded-2xl bg-neutral-200" />
            <div className="h-40 rounded-2xl bg-neutral-200" />
            </div>

            <div className="flex flex-col gap-3">
            <div className="h-5 w-1/3 bg-neutral-300 rounded" />
            <div className="h-4 w-4/5 bg-neutral-300 rounded" />
            <div className="h-4 w-3/4 bg-neutral-300 rounded" />
            <div className="h-4 w-2/3 bg-neutral-300 rounded" />
            </div>
        </div>

        </div>
    );
}